"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var OverridableComponent = /** @class */ (function (_super) {
    __extends(OverridableComponent, _super);
    function OverridableComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            components: undefined
        };
        _this.resolveComponents = function () {
            var _a, _b;
            return (_b = (_a = _this.props.overrides) === null || _a === void 0 ? void 0 : _a[_this.props.name]) === null || _b === void 0 ? void 0 : _b.map(function (_a) {
                var _b;
                var module = _a.module, component = _a.component;
                return ({
                    key: "".concat(module, ":").concat(component),
                    element: (_b = window.botpress[module]) === null || _b === void 0 ? void 0 : _b[component]
                });
            }).filter(function (x) { return x.element; });
        };
        return _this;
    }
    OverridableComponent.prototype.componentDidMount = function () {
        this.loadComponents();
    };
    OverridableComponent.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.overrides !== this.props.overrides) {
            this.loadComponents();
        }
    };
    OverridableComponent.prototype.componentDidCatch = function (error, info) {
        console.error("Error in overridable component ".concat(this.props.name, ". Loading original component."), error, info);
        this.setState({ components: [{ key: 'original', element: this.props.original }] });
    };
    OverridableComponent.prototype.loadComponents = function () {
        this.setState({ components: this.resolveComponents() || [{ key: 'original', element: this.props.original }] });
    };
    OverridableComponent.prototype.render = function () {
        var _this = this;
        var components = this.state.components;
        return components
            ? components.map(function (_a) {
                var Element = _a.element, key = _a.key;
                return Element && react_1.default.createElement(Element, __assign({ key: key }, _this.props));
            })
            : null;
    };
    return OverridableComponent;
}(react_1.default.Component));
exports.default = (0, mobx_react_1.inject)(function (_a) {
    var store = _a.store;
    return ({
        store: store,
        overrides: store.config.overrides
    });
})(OverridableComponent);
